import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import PropTypes from "prop-types";
import { size, values, map } from "lodash/fp";
import { Avatar } from "../avatar/avatar.es.js";
import { Tooltip } from "../tooltip/tooltip.es.js";
import { clusteredAvatarsContext } from "./clustered-avatars-context.es.js";
import { ClusteredAvatarsWrapper, ClusteredAvatarsItem, ClusteredAvatarsRemainder } from "./clustered-avatars.styles.es.js";
const { Provider } = clusteredAvatarsContext;
const propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  magnitude: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge"]),
  max: PropTypes.number,
  tooltips: PropTypes.bool,
  variant: PropTypes.oneOf(["individual", "organisation"])
};
const defaultProps = {
  description: "others",
  magnitude: "medium",
  max: void 0,
  tooltips: false,
  variant: "individual"
};
const ClusteredAvatars = ({
  children,
  description,
  magnitude,
  max,
  tooltips,
  variant
}) => {
  const [items, setItems] = useState({});
  const length = size(items);
  const total = Number.isFinite(max) && max < length ? Math.max(1, max - 1) : length;
  const remainder = length - total;
  return /* @__PURE__ */ jsxs(Provider, { value: setItems, children: [
    children,
    /* @__PURE__ */ jsxs(ClusteredAvatarsWrapper, { children: [
      values(items).slice(0, total).map((item, index) => /* @__PURE__ */ jsx(
        ClusteredAvatarsItem,
        {
          index,
          magnitude,
          children: /* @__PURE__ */ jsx(
            Tooltip,
            {
              disabled: !tooltips,
              placement: "top",
              subtitle: item.subtitle,
              title: item.title,
              children: /* @__PURE__ */ jsx(
                Avatar,
                {
                  ...item,
                  appearance: "outlined",
                  disabled: index > 0,
                  magnitude,
                  variant,
                  children: item.children
                }
              )
            }
          )
        },
        item.id
      )),
      remainder > 0 && /* @__PURE__ */ jsxs(ClusteredAvatarsRemainder, { children: [
        "+",
        " ",
        /* @__PURE__ */ jsx(
          Tooltip,
          {
            disabled: !tooltips,
            placement: "bottom",
            title: map("title", items).slice(total).join("\n"),
            children: /* @__PURE__ */ jsxs("span", { children: [
              remainder,
              " ",
              description
            ] })
          }
        )
      ] })
    ] })
  ] });
};
ClusteredAvatars.propTypes = propTypes;
ClusteredAvatars.defaultProps = defaultProps;
export {
  ClusteredAvatars
};
